import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, XCircle, Sparkles } from 'lucide-react';
const tableData = [{
  sit: 'Necesitás captar clientes nuevos sin llamar en frío',
  sin: 'Publicás "ofrezco servicios contables" y nadie responde',
  con: 'Estrategia de contenido lista con 30 posts redactados por IA'
}, {
  sit: 'Querés posicionarte en LinkedIn como referente',
  sin: 'Perfil genérico de "Contador Público"',
  con: 'Bio Tech-Ready + Plantilla de perfil optimizado'
}, {
  sit: 'Querés ofrecer el servicio CFO pero no sabés cómo presentarlo',
  sin: 'Lo inventás en el momento con cada cliente',
  con: 'Presentación CFO lista para adaptar en 10 minutos'
}, {
  sit: 'Necesitás una propuesta comercial para un cliente grande',
  sin: 'La escribís desde cero cada vez',
  con: 'Prompt de Propuesta Comercial + Template Word editable'
}, {
  sit: 'Querés activar referidos de tus clientes actuales',
  sin: 'Esperás que lleguen solos',
  con: 'Sistema de Referidos en 3 pasos con mensajes listos'
}];
const includes = ['30 posts redactados con IA para LinkedIn e Instagram (listos para publicar)', 'Bio y perfil Tech-Ready para LinkedIn (template editable)', 'Presentación CFO Externalizado en PDF (personalizable)', 'Template de Propuesta Comercial en Word (editable)', 'Sistema de Referidos en 3 pasos con mensajes listos', 'Guía de Especialización por Rubro (Gastronomía / Tecnología / Comercio)', 'Mini-Curso "Tu Primera Semana con IA" en video (20 minutos)'];
export function KitScale() {
  return <section className="py-20 bg-brand-darker border-y border-slate-800/50" data-id="element-208">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-209">
        <FadeIn className="text-center mb-16" data-id="element-210">
          <div className="inline-flex items-center justify-center p-3 bg-brand-accent/10 rounded-full mb-6" data-id="element-211">
            <Sparkles className="w-8 h-8 text-brand-accent" data-id="element-212" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-213">
            🕊️ ¿QUÉ AGREGA EL SISTEMA CLIENTES "CONTADOR PREMIUM"?
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} className="mb-16 overflow-x-auto" data-id="element-214">
          <table className="w-full text-left border-collapse min-w-[800px]" data-id="element-215">
            <thead data-id="element-216">
              <tr className="border-b border-slate-700" data-id="element-217">
                <th className="p-4 text-slate-400 font-medium w-1/3" data-id="element-218">
                  Situación en el estudio
                </th>
                <th className="p-4 text-slate-400 font-medium w-1/3 bg-red-950/10" data-id="element-219">
                  ❌ Sin Sistema Clientes
                </th>
                <th className="p-4 text-brand-accent font-bold w-1/3 bg-brand-accent/5" data-id="element-220">
                  ✅ Con Sistema Clientes
                </th>
              </tr>
            </thead>
            <tbody data-id="element-221">
              {tableData.map((row, i) => <tr key={i} className="border-b border-slate-800/50 hover:bg-slate-800/20 transition-colors" data-id="element-222">
                  <td className="p-4 text-white font-medium" data-id="element-223">{row.sit}</td>
                  <td className="p-4 text-slate-400 bg-red-950/5" data-id="element-224">{row.sin}</td>
                  <td className="p-4 text-emerald-400 bg-brand-accent/5 font-medium" data-id="element-225">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </FadeIn>

        <FadeIn delay={0.2} className="max-w-3xl mx-auto" data-id="element-226">
          <div className="bg-brand-card border border-brand-accent/30 rounded-2xl p-8" data-id="element-227">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-228">
              <CheckCircle2 className="w-6 h-6 text-brand-accent" data-id="element-229" />
              EL SISTEMA CLIENTES INCLUYE:
            </h3>
            <div className="space-y-4" data-id="element-230">
              {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-231">
                  <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0 mt-0.5" data-id="element-232" />
                  <span className="text-slate-300" data-id="element-233">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}